import axios from '@axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {},
  mutations: {},
  actions: {

    fetchMyProducts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/product/products', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMyProduct(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/product/products/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addMyProduct(ctx, productData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/product/products', { product: productData })
          .then(response => resolve(response))
          .catch(error => reject(error))
          
         
      })
    },
  }
}
